import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../generic-components/Icon';
import CloseIcon from '../../../assets/svg/x-icon-v2.svg';
import Heading from '../../../generic-components/Heading';
import { STYLES } from '../consts';
import { HeaderNotification } from '../../MailCheck/components/HeaderNotification';
import { VIEWS_MAP } from '../../../router/constants';
import { useStore } from '../../../store';
import Button from '../../../generic-components/Button';

interface IProps {
    title?: string;
    upperMessage?: string;
}

export const Header = ({ title = '', upperMessage }: IProps) => {
  const navigate = useNavigate();
  const { setUpperMessageContent } = useStore(state => state);
  const [upperMessageContent, setMessageContent] = useState<string>(upperMessage || '');

  return (
    <div className={STYLES.HEADER_WRAPPER}>
      <Button className='rounded-[50%] hover:bg-bw02 py-[4px] px-[4px] flex items-center justify-center' id='' childElement={<Icon onClick={() => navigate(`/${VIEWS_MAP.DASHBOARD}`)} className={STYLES.HEADER_ICON} src={CloseIcon} />} />
      <Heading title={title} className={STYLES.HEADER_TITLE} />
      <span />
      {upperMessageContent && <HeaderNotification autoCloseSec={8} onTimeElapsed={() => { setMessageContent(''); setUpperMessageContent(''); }} title={upperMessageContent} />}
    </div>
  );
};
